import { CostDocumentItemsPair } from "@/models/api/costDocuments/CostDocumentItemsPairs";
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsString, ValidateNested } from "class-validator";

export class DocumentDetails {
  @IsString()
  @Expose()
  currency!: string;
  @IsNumber()
  @Expose()
  gross!: number;
  @IsNumber()
  @Expose()
  grossInCurrency!: number;
  @IsString()
  @Expose()
  saleDate!: string;
  @IsString()
  @Expose()
  documentNumber!: string;
  @IsString()
  @Expose()
  issueDate!: string;
}

export class DocumentItemDetails {
  @IsString()
  @Expose()
  id!: string;
  @IsNumber()
  @Expose()
  gross!: number;
  @IsNumber()
  @Expose()
  grossInCurrency!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsNumber()
  @Expose()
  purchaseNetPrice!: number;
  @IsString()
  @Expose()
  purchaseNetPriceCurrency!: string;
  @IsString()
  @Expose()
  purchaseNetPriceExchangeDate!: string;
  @IsNumber()
  @Expose()
  purchaseNetPriceExchangeRate!: number;
  @IsNumber()
  @Expose()
  purchaseNetPriceInCurrency!: number;
  @IsNumber()
  @Expose()
  pairLeftAmount!: number;
  @IsNumber()
  @Expose()
  pairLeftAmountInCurrency!: number;
  @IsBoolean()
  @Expose()
  isSettled!: boolean;
}

export class DocumentItemPairDetails {
  @Type(() => DocumentDetails)
  @ValidateNested()
  @Expose()
  documentDetails!: DocumentDetails;
  @Type(() => DocumentItemDetails)
  @ValidateNested()
  @Expose()
  documentItemDetails!: DocumentItemDetails;
  @Type(() => CostDocumentItemsPair)
  @ValidateNested()
  @Expose()
  costDocumentItems!: Array<CostDocumentItemsPair>;
}
